import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../itrust_common/components/AsyncComponent';

const ExamProcedurePricing = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/procedurePricing/ProcedurePricing')
)
const DefaultBillingProvider = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/providerDetails/DefaultBillingProvider')
)
const DefaultProvider = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/defaultProvider/DefaultProvider')
)
const ServiceProviderLocation = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/providerDetails/ServiceProviderLocation')
)
const PrescriptionExpiration = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/prescriptionExpiration/PrescriptionExpiration')
)
const MessageTracking = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/messageTracking/MessageTracking')
)
const StoreContact = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/storeContact/StoreContact')
)
const DeviceIntegration = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/deviceIntegration/DeviceIntegration')
)
const StoreEyeglassLensType = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassLensType')
)
const StoreEyeglassAddons = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassAddons')
)
const StoreStockLenses = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreStockLenses')
)
const StoreEyeglassFrame = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassFrame')
)
const StoreEyeglassLensMaterial = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassLensMaterial')
)
const StoreMiscItems = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreMiscItems')
)
const StoreContactLens = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/contactLens/StoreContactLens')
)
const StoreCleaningSolution = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/contactLens/StoreCleaningSolution')
)
const StoreCalendarSetting = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/calendarSettings/StoreCalendarSetting')
)
const StoreAnonymousSetting = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/calendarSettings/StoreAnonymousSetting')
)
const StaffAuthControl = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/staffAuth/StaffAuthControl')
)

const OrganisationStoreRoutes = (
  <Switch>
    {/* store office settings */}
    <Route exact path="/organisation/stores/:id/settings/store/exam-procedure-pricing" component={ExamProcedurePricing} />
    <Route exact path="/organisation/stores/:id/settings/store/default-billing-provider" component={DefaultBillingProvider} />
    <Route exact path="/organisation/stores/:id/settings/store/default-provider" component={DefaultProvider} />
    <Route exact path="/organisation/stores/:id/settings/store/service-provider-location" component={ServiceProviderLocation} />
    <Route exact path="/organisation/stores/:id/settings/store/prescription-expiration" component={PrescriptionExpiration} />
    <Route exact path="/organisation/stores/:id/settings/store/device-integration" component={DeviceIntegration} />
    <Route exact path="/organisation/stores/:id/settings/store/staffs-auth" component={StaffAuthControl} />
    <Route exact path="/organisation/stores/:id/settings/message-tracking-number" component={MessageTracking} />
    <Route exact path="/organisation/stores/:id/settings/contact" component={StoreContact} />
    <Route exact path="/organisation/stores/:id/settings/calendar/calendar-setting" component={StoreCalendarSetting} />
    <Route exact path="/organisation/stores/:id/settings/calendar/anonymous-booking" component={StoreAnonymousSetting} />
    <Redirect exact from="/organisation/stores/:id/settings/calendar" to="/organisation/stores/:id/settings/calendar/calendar-setting" />
    <Redirect exact from="/organisation/stores/:id/settings/store" to="/organisation/stores/:id/settings/store/exam-procedure-pricing" />
    {/* order-inventory routes */}
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass" component={StoreEyeglassLensType} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/lens-material" component={StoreEyeglassLensMaterial} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/frame" component={StoreEyeglassFrame} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/add-ons" component={StoreEyeglassAddons} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/stock-lenses" component={StoreStockLenses} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/misc" component={StoreMiscItems} />
    {/* contact lens */}
    <Route exact path="/organisation/stores/:id/settings/order-inventory/contact-lens" component={StoreContactLens} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/contact-lens/cleaning-solution" component={StoreCleaningSolution} />
  </Switch>
);


export default OrganisationStoreRoutes;
